import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { defaultValueForFavouriteTripsForToday } from "../../../../Orchestrator/Recoils/MyAccount";
import { IUserResponse } from "../../../../Orchestrator/Types/Index";
import { IFavoriteTripsForTodayFields } from "../../../../Orchestrator/Types/Types/OffersResponse";
import { getTranslatedMessage } from "../../../../Lib/Utils/i18n";

interface IUpdatePersonalizeFavoriteTripFieldValueParams {
    userData: IUserResponse, listOfStops: any
}

class SetFavoriteTripsForTodayFieldsToAtomAction extends BaseAction<void, IUpdatePersonalizeFavoriteTripFieldValueParams> {
    override async run(): Promise<void> {
        try {
            const { userData, listOfStops } = this.params!;
            const preferredTrips = userData?.railPreferences?.preferredTrips?.[0];

            const favoriteTrips = [...defaultValueForFavouriteTripsForToday].map((field: IFavoriteTripsForTodayFields) => {
                const updatedField = { ...field }
                if (updatedField.name === "from") {
                    updatedField.value = preferredTrips?.origin || "";
                    let valueLabel = ""
                    listOfStops.forEach((d: any) => {
                        if (d.id === preferredTrips?.origin) {
                            valueLabel = d?.name || ""
                        }
                        if (valueLabel == "" && d?.subStations?.length > 0) {
                            d.subStations.forEach((sd: any) => {
                                if (sd.id === preferredTrips?.origin) {
                                    valueLabel = sd?.name || ""
                                }
                            })
                        }
                    })
                    updatedField.valueLabel = valueLabel
                } else if (updatedField.name === "to") {
                    updatedField.value = preferredTrips?.destination || ""
                    let valueLabel = ""
                    listOfStops.forEach((d: any) => {
                        if (d.id === preferredTrips?.destination) {
                            valueLabel = d?.name || ""
                        }
                        if (valueLabel == "" && d?.subStations?.length > 0) {
                            d.subStations.forEach((sd: any) => {
                                if (sd.id === preferredTrips?.destination) {
                                    valueLabel = sd?.name || ""
                                }
                            })
                        }
                    })
                    updatedField.valueLabel = valueLabel
                }
                else if (updatedField.name === "classTicketOption") {
                    updatedField.value = preferredTrips?.classType || ""
                    if (preferredTrips?.classType?.includes("STANDARD") && preferredTrips?.ticketOption === "SFC") {
                        updatedField.valueLabel = getTranslatedMessage("ticketOption.SFC.label", "Standard Flex")
                    } else if (preferredTrips?.classType?.includes("STANDARD") && preferredTrips?.ticketOption === "SFF") {
                        updatedField.valueLabel = getTranslatedMessage("ticketOption.SFF.label", "Standard Flex Plus")
                    } else if (preferredTrips?.classType?.includes("PREMIUM") && preferredTrips?.ticketOption === "PFF") {
                        updatedField.valueLabel = getTranslatedMessage("ticketOption.PFF.label", "Premium Flex Plus")
                    }
                }
                return updatedField
            });
            updateRecoilState("favoriteTripsForTodayFieldsAtom", favoriteTrips)
        } catch (error: any) {
            console.log("Error setFavoriteTripsForTodayFieldsToAtom", error?.message);
        }
    }
}

export const setFavoriteTripsForTodayFieldsToAtomAction = new SetFavoriteTripsForTodayFieldsToAtomAction();
